// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SURC","placeholdersHeader":"styles_placeholdersHeader__o9ar_","editorStyle":"styles_editorStyle__1CXsR","placeholdersBox":"styles_placeholdersBox__1XQFQ"};